<template>
  <div class="wrapper">
    <side-bar>
      <sidebar-link to="/overview" v-if="allowDashboard">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link to="/newPUSelection" v-if="allowNewPU">
        <i class="nc-icon nc-simple-add"></i>
        <p>Nové PU</p>
      </sidebar-link>
      <sidebar-link to="/userrolesform" v-if="allowRunningPU">
        <i class="nc-icon nc-button-play"></i>
        <p>Probíhající PU</p>
      </sidebar-link>
      <sidebar-link to="/userrolesform" v-if="allowArchive">
        <i class="nc-icon nc-attach-87"></i>
        <p>Archiv PU</p>
      </sidebar-link>
      <sidebar-link to="/userrolesform" v-if="allowDocuments">
        <i class="nc-icon nc-layers-3"></i>
        <p>Dokumenty a úkoly</p>
      </sidebar-link>
      <sidebar-link to="/userrolesform" v-if="allowContacts">
        <i class="nc-icon nc-badge"></i>
        <p>Kontakty</p>
      </sidebar-link>
      <sidebar-link to="/users" v-if="allowUsers">
        <i class="nc-icon nc-single-02"></i>
        <p>Uživatelé</p>
      </sidebar-link>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>

<script>
  import TopNavbar from './TopNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import vueFormHelper from '@/js/VueFormHelper.js';

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },
    data () {
      return {
        allowDashboard: false,//true,
        allowNewPU: vueFormHelper.userHasPermission(this, 22),
        allowRunningPU: false,//vueFormHelper.userHasPermission(this, 23),
        allowArchive: false,//vueFormHelper.userHasPermission(this, 24),
        allowDocuments: false,//vueFormHelper.userHasPermission(this, 25),
        allowContacts: false,//vueFormHelper.userHasPermission(this, 26),
        allowUsers: vueFormHelper.userHasPermission(this, 27),
      }
    },
  }

</script>